import React, { useState } from 'react'
import GenericButton from '../GenericButton'
import RotateLeftIcon from '@mui/icons-material/RotateLeft'
import { ButtonSize, ButtonType } from '../GenericButton/styles'
import { grey } from '../../colors'
import GenericModal from '../GenericModal'
import CustomTooltip from '../CustomTooltip'

interface ResetTableButtonProps {
  buttonLabel: string
  onConfirm: any
  resetTooltip?: string
  resetModalText: string
  isLoading?: boolean
}

export const ResetTableButton: React.FC<ResetTableButtonProps> = ({
  buttonLabel,
  onConfirm,
  resetTooltip,
  resetModalText,
  isLoading = false
}) => {
  const handleReset = async (): Promise<void> => {
    try {
      onConfirm()
    } finally {
      setIsModalOpen(false)
    }
  }
  const [isModalOpen, setIsModalOpen] = useState(false)
  return (
    <>
      <CustomTooltip title={resetTooltip ?? undefined} placement='top'>
        <GenericButton
          buttonType={ButtonType.Secondary}
          buttonSize={ButtonSize.Medium}
          label={buttonLabel}
          sx={{ color: grey[950] }}
          fontWeight='bold'
          startIcon={<RotateLeftIcon />}
          onClick={() => { setIsModalOpen(true) }}
          loading={isLoading}
          circularProgressStyles={{ color: grey[300] }}
        />
      </CustomTooltip>
      <GenericModal
        isOpen={isModalOpen}
        onClose={() => { setIsModalOpen(false) }}
        title={buttonLabel}
        maxWidth='sm'
        onConfirm={handleReset}
        confirmButtonLoading={isLoading}
      >
        {resetModalText}
      </GenericModal>
    </>
  )
}
